import { render } from "./Box.vue?vue&type=template&id=b7384228&scoped=true&ts=true"
import script from "./Box.vue?vue&type=script&lang=ts"
export * from "./Box.vue?vue&type=script&lang=ts"

import "./Box.vue?vue&type=style&index=0&id=b7384228&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7384228"]])

export default __exports__